angular.module('questionForm', ['questionManagement', 'common']);

require('./routes');

require('./components/edit_question_group_wrapper');
